var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row justify-end"},[_c('MonthSelector',{on:{"select":_vm.load}})],1),_c('CreditReturns',{attrs:{"range":_vm.range}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }